import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  mediaListController: [
    'runtimeConstant',
    '$scope',
    '$filter',
    'authService',
    'service',
    function (runtimeConstant, $scope, $filter, authService, service) {
      'use strict';

      function isSysAdmin() {
        return authService.isSysAdmin();
      }

      function isLoading() {
        return $scope.loading || !authService.user.email;
      }

      function selectMedia(item) {
        $scope.$parent.selectedItem = item;
        $scope.$parent.selectedItems = true;
      }

      function loadMore() {
        $scope.totalDisplayed += 50;
      }

      function parent_deleteMedia() {
        swal
          .fire({
            title: $filter('translate')('CONFIRM.DELETE.MEDIA'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: $filter('translate')('YES'),
            cancelButtonText: $filter('translate')('NO'),
          })
          .then(function () {
            var folder = $scope.$parent.selectedItem;

            service.delete(folder).then(
              function (data) {
                if (data.status === 200) {
                  $scope.$parent.list();
                }
              },
              function (error) {
                swal.fire({
                  title: error.title,
                  text: error.text,
                  showCancelButton: false,
                  confirmButtonText: $filter('translate')('OK'),
                });
              }
            );
          });
      }

      function parent_downloadMedia() {
        var folder = $scope.$parent.selectedItem;
        service.download(folder).then(
          function (url) {
            window.open(url, '_blank');
          },
          function (error) {
            swal.fire({
              title: error.title,
              text: error.text,
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          }
        );
      }

      function run() {
        try {
          $scope.$parent.selectedItem = {};
          $scope.totalDisplayed = 50;

          $scope.isSysAdmin = logWrapper(
            isSysAdmin,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isLoading = logWrapper(
            isLoading,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectMedia = logWrapper(
            selectMedia,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadMore = logWrapper(
            loadMore,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.deleteMedia = logWrapper(
            parent_deleteMedia,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.downloadMedia = logWrapper(
            parent_downloadMedia,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
